<template>
  <div class="container" ref="container">
    <div class="content" style="margin-top: 4em;">
      <h4 class="has-text-centered">Åpenhetsloven § 5</h4>

      <h4>Redegjørelse for aktsomhetsvurderinger i Stadssalg konsernet</h4>

      <p>
        Denne redegjørelsen er utarbeidet i henhold til åpenhetsloven § 5 og
        omfatter aktsomhetsvurderinger i Stadssalg konsernet for perioden
        1.7.2022 – 31.12.2022.
      </p>

      <p>
        Stadssalg er ett ledende selskap innenfor avhending i Norge og ble
        stiftet i 1997. Det var Stig Otto Nilsen som startet selskapet og er
        100% eier samt konsernsjef. Vi jobber for de fleste norske banker og
        finansieringsbyrå samt advokater, bobestyrere, politiet og selger utstyr
        som er misligholdt eller kommer fra konkursbo.
      </p>

      <p>
        Vi er et landsdekkende konsern med egne kontorer i Tromsø, Bodø
        (hovedkontor), Trondheim, Bergen, Stavanger og Oslo.
      </p>

      <p>
        Konkonsernet eier og forvalter også en stor eiendomsportefølje på 50
        næringseiendommer rundt om i Norge. I tillegg eier og driver vi Scandic
        Fauske Hotel.
      </p>

      <p>
        Vi er totalt 71 medarbeidere i konsernet fordelt på alle våre kontor.
        Bodø er vår hovedbase og her er det 15 medarbeidere. Her har vi mottak
        for hele landet hvor alt av papirarbeid ordens og gjøres klar for salg.
        Vi har en egen salgsavdeling hvor det er høy aktivitet og det selges
        mange objekter (mest kjøretøy og caravan samt løsøre) mest som daglig
        gjennom vår auksjonsside stadssalg.no. Vi har kunder fra hele landet
        både private og forretningskunder. I tillegg har vi ansatt egne
        oppsøkere (som har inkassokompetanse) rundt om i landet. Ledergruppen
        består av konsernsjef, eiendomsforvalter og NK (som også er
        hotelldirektør) i tillegg til å ha HR ansvaret i konsernet. Vi er en
        effektiv og veldrevet organisasjon med stor tillit i markedet.
      </p>

      <h4>1. Beskrivelse av retningslinjer og rutiner</h4>

      <p>
        Stadssalgkonsernet har en klar beskrivelse av virksomhetens
        retningslinjer og rutiner for å håndtere faktiske og potensielle
        negative konsekvenser for grunnleggende menneskerettigheter og
        anstendige arbeidsforhold.
      </p>

      <ul>
        <li>
          Vi har forankret arbeidet med menneskerettigheter og anstendige
          arbeidsforhold internt og eksternt, gjennom styrevedtak,
          miljøsertifisering, innkjøpsordninger og rutiner for håndtering av
          informasjonskrav, mv.
        </li>

        <li>
          Vi har gjennom vår HMS samarbeidspartner DIN HMS tatt i bruk en App
          (KUBA) som er en mulig varslingskanal / klagekanal for medarbeiderne.
        </li>

        <li>
          Vi har ellers planer om ytterligere forankring av åpenhetslovens med
          kompetanseheving i organisasjonen, involvering av ansatte, gjennomgang
          av eksisterende leverandøravtaler, utarbeidelse av etiske krav til
          leverandører, såkalte Suppliers Code of Conduct, er standardvilkår som
          legges til ved inngåelse av leverandøravtaler.
        </li>
      </ul>

      <h4>
        2. Opplysninger om negative konsekvenser og vesentlig risiko for
        negative konsekvenser
      </h4>

      <p>
        Vi har til nå i virksomheten ikke avdekket noen negative konsekvenser
        eller vesentlig risiko for negative konsekvenser gjennom våre
        aktsomhetsvurderinger (KUBA) Men dette vil være en kontinuerlig fokus i
        virksomheten og påminnes om i fellesmøter.
      </p>

      <h4>3. Opplysninger om tiltak</h4>

      <p>
        Vi har i dag etablert gode rutiner og tiltak for å motta og håndtere
        klager.
      </p>

      <p>
        Vi stiller krav til leverandører eller forretningspartnere gjennom å
        kartlegge deres virksomhet med spørreskjema.
      </p>

      <p>
        Vi har sendt ut 14 spørreskjemaer hvor vi ønsker å undersøke nærmere
        våre leverandører innen transport som vi benytter.
      </p>

      <p>
        Forventet resultat av tiltak er å opprettholde en virksomhet med gode
        etiske retningslinjer samt rettferdige og profesjonelle arbeidsforhold.
      </p>

      <h4>Dato og signaturer</h4>

      <p>Bodø, 29.6.2023</p>

      <div class="columns">
        <div class="column">
          <h4>Stig Otto Nilsen</h4>
          <p>Stadssalg Holding AS (daglig leder og nestleder i styret)</p>
          <p>Stadssalg AS (daglig leder og styremedlem)</p>
        </div>

        <div class="column">
          <h4>Øvind Eidnes</h4>
          <p>Stadssalg Holding AS (styreleder)</p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <h4>Barbro Helen Myhre</h4>
          <p>Stadssalg Holding AS (styremedlem)</p>
          <p>Stadssalg AS (styremedlem)</p>
        </div>

        <div class="column">
          <h4>Trine Nøvik</h4>
          <p>Stadssalg Holding AS (styremedlem)</p>
          <p>Stadssalg AS (styremedlem)</p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <h4>Viggo Normann</h4>
          <p>Stadssalg AS (styreleder)</p>
          <p>E6 Transport AS (styreleder)</p>
        </div>

        <div class="column">
          <h4>Espen Pedersen Teksnes</h4>
          <p>Caranord AS (daglig leder)</p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <h4>John Robin Christoffersen</h4>
          <p>Caranord AS (styreleder)</p>
        </div>

        <div class="column">
          <h4>Espen Pedersen Teksnes</h4>
          <p>Caranord AS (styremedlem)</p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <h4>Tor Gunnar Ness</h4>
          <p>E6 Transport AS (daglig leder)</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
h4 {
  margin-top: 2em !important;
}
</style>
